/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonIdContactDataQueryResponse,
  GetApiV1PersonIdContactDataPathParams,
  GetApiV1PersonIdContactData401,
  GetApiV1PersonIdContactData404,
  GetApiV1PersonIdContactData500,
} from "../../types/personRegisterController/GetApiV1PersonIdContactData.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonIdContactData } from "../../clients/personRegisterController/getApiV1PersonIdContactData.ts";

export const getApiV1PersonIdContactDataQueryKey = (
  id: GetApiV1PersonIdContactDataPathParams["id"],
) => [{ url: "/api/v1/person/:id/contact-data", params: { id: id } }] as const;

export type GetApiV1PersonIdContactDataQueryKey = ReturnType<
  typeof getApiV1PersonIdContactDataQueryKey
>;

export function getApiV1PersonIdContactDataQueryOptions(
  id: GetApiV1PersonIdContactDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonIdContactDataQueryKey(id);
  return queryOptions<
    GetApiV1PersonIdContactDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdContactData401
      | GetApiV1PersonIdContactData404
      | GetApiV1PersonIdContactData500
    >,
    GetApiV1PersonIdContactDataQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonIdContactData(id, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os dados de contato de uma pessoa (telefones, preferências de comunicação). **(Requer Authorization para autenticação)**
 * @summary Obter dados de contato (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/contact-data}
 */
export function useGetApiV1PersonIdContactData<
  TData = GetApiV1PersonIdContactDataQueryResponse,
  TQueryData = GetApiV1PersonIdContactDataQueryResponse,
  TQueryKey extends QueryKey = GetApiV1PersonIdContactDataQueryKey,
>(
  id: GetApiV1PersonIdContactDataPathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonIdContactDataQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonIdContactData401
          | GetApiV1PersonIdContactData404
          | GetApiV1PersonIdContactData500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1PersonIdContactDataQueryKey(id);

  const query = useQuery(
    {
      ...getApiV1PersonIdContactDataQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonIdContactData401
      | GetApiV1PersonIdContactData404
      | GetApiV1PersonIdContactData500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
